import Spinner from "react-bootstrap/Spinner";

function Loader({ type }) {
  if (type === "small") {
    return (
      <div className="mx-auto " style={{ width: "50px" }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }
  return (
    <div
      className="mx-auto "
      style={{ width: "50px", height: "250px", marginTop: " 20%" }}
    >
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
}

export default Loader;
